import type { DriverBalance } from '@chukua/common';

/** An amount with its currency, never bare: a driver can hold balances in more than one and they are not added together. The sign is dropped; the wording says which way it runs. */
export function formatLedgerAmount(amountMinor: number, currency: string): string {
  const major = (Math.abs(amountMinor) / 100).toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${currency} ${major}`;
}

/** Positive balances are what the driver owes the company; negative what the company owes the driver. */
export function balanceSentence(balance: DriverBalance): string {
  const amount = formatLedgerAmount(balance.amountMinor, balance.currency);
  return balance.amountMinor > 0 ? `Owes the company ${amount}` : `Owed by the company ${amount}`;
}

/** What a single entry did to the balance, for the ledger table's amount column. */
export function entryEffectLabel(deltaMinor: number): 'Driver owes more' | 'Driver owes less' {
  return deltaMinor > 0 ? 'Driver owes more' : 'Driver owes less';
}
